import { Content } from 'Constants/styles';
import { useParams } from 'react-router-dom';

import MerchantInvoicesList from './MerchantInvoicesList';

const MerchantInvoices = () => {
  const { merchantId } = useParams<{ merchantId: string; manage: string }>();

  return (
    <>
      <Content className="merchant-invoices-content">
        <MerchantInvoicesList merchantId={merchantId} />
      </Content>
    </>
  );
};

export default MerchantInvoices;
